import React, { useState, useEffect, useRef } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import { theme } from '../../../';
import { Link, useHistory } from "react-router-dom"
import CsvParser from './CsvParser';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../../components/modal/modal';

const AddEditTestSeries = props => {
    const [addSectionModalVisible, setAddSectionModalVisible] = useState(false)
    const [addSectionLoading, setAddSectionLoading] = useState(false)
    const [addQuestionModalVisible, setAddQuestionModalVisible] = useState(false)
    const [sectionName, setSectionName] = useState()
    const [testSeriesData, setTestSeriesData] = useState([])
    const [csvLoader, setCsvLoader] = useState('')
    const [positiveMarks, setPositiveMarks] = useState()
    const [negativeMarks, setNegativeMarks] = useState()
    const [question, setQuestion] = useState()
    const [processing, setProcessing] = useState(false)
    const [options, setOptions] = useState([{value: '', prompt: ''},{value: '', prompt: ''},{value: '', prompt: ''},{value: '', prompt: ''}])
    // const [correctOption, setCorrectOption] = useState()
    const [solution, setSolution] = useState()
    const [selectedOption, setSelectedOption] = useState()
    const [seriesId, setSeriesId] = useState()
    const history = useHistory();

    const addSectionNameHandler =()=>{
        testSeriesData.push({title: sectionName})
    }
    const callbackLoader = (type) => {
        setCsvLoader(type)
    }

    const multipleQueCallBack = (response) => {
        // if (response.status == 200) {
        //     response.json().then(data => {
        //         var arr = [...testSeries]
        //         arr = arr.concat(data)
        //         setTestSeries(arr)
        //     })
        //     setSnackBarMessage("Questions Added Successfully!!")
        //     setIsSnackBarShow(true)
        // }
    }

    const callbackQuestion = (data) => {
        // addMultipleQuestion(data, multipleQueCallBack)
    }

    
    const errorsCallback = (data) => {
        // setSnackBarMessage("Something Went Wrong. Please Try Again Later!!")
        // setIsSnackBarShow(true)
    }

    const onQuestionSubmitHandler = () => {
        // setSnackBarMessage("Something Went Wrong. Please Try Again Later!!")
        // setIsSnackBarShow(true)
    }

    return (
        <div>
            <div class="page-breadcrumb  d-md-flex align-items-center mb-3">
                <div class="breadcrumb-title pr-3">Test Series</div>
                <div class="pl-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:;"><i class='bx bx-home-alt'></i></a>
                            </li>
                        </ol>
                    </nav>
                </div>
                <div class="ml-auto">
                    <div class="btn-group">
                        <div>
                            <button type="button" class="btn btn-success mr-3" data-toggle="modal" data-target="#addSectionModal" onClick={() => setAddSectionModalVisible('add')}>
                                + ADD SECTION
                            </button>
                        </div>
                        <button type="button" class="btn btn-dark" onClick={() => history.goBack()}>Go Back</button>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end" style={{marginBottom:10,marginRight:5}}>
                {/* <h6 >Total Number of Question : {testSeries.length}</h6> */}
            </div>
            <div>
                <CsvParser callbackLoader={callbackLoader} callbackQuestion={callbackQuestion} testSeriesId={seriesId} errorsCallback={errorsCallback} />
                <br />
            </div>
            <div class="ml-auto">
                    <div class="btn-group">
                        <div>
                            <button type="button" class="btn btn-success mr-3" data-toggle="modal" data-target="#addSectionModal" onClick={() => setAddQuestionModalVisible(true)}>
                                + ADD QUESTION
                            </button>
                        </div>
                        <button type="button" class="btn btn-dark" onClick={() => history.goBack()}>Go Back</button>
                    </div>
                </div>
            <div class="modal fade" data-backdrop="static" data-keyboard="false" id="addSectionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Add Section</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">	<span aria-hidden="true">&times;</span>
                        </button>
                        </div>
                        <div class="modal-body">
                            <label>Section Name</label>
                            <input className="form-control" value={sectionName} placeholder="Section Name" onChange={(e) => setSectionName(e.target.value)} />
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal" id="addPlaylistCloseBtn">Close</button>
                                <button type="button" class="btn btn-primary" onClick={() => addSectionNameHandler()}>{addSectionLoading?(
                                    <ClipLoader color={theme.primaryColor}   loading={addSectionLoading}     />
                                ):("Save changes")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
            visible={addQuestionModalVisible} 
            setModalVisible={setAddQuestionModalVisible} 
            modalId={"questionAddEditModal"} 
            >
                <form onSubmit={onQuestionSubmitHandler}>
                    <ModalHeader>
                        <h5 className="modal-title">Add Question</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">	<span aria-hidden="true">&times;</span>
                        </button>
                    </ModalHeader>   
                    <ModalBody> 
                        <div>
                            <div className="form-row">
                                <div className="col-6">
                                    <label>Positive Marks</label>
                                    <input type="text" className="form-control" value={positiveMarks} placeholder="Positive Marks" onChange={(e)=>setPositiveMarks(e.target.value)} />
                                </div>
                                <div className="col-6">
                                    <label>Negative Marks</label>
                                    <input type="text" className="form-control" value={negativeMarks} placeholder="Negative Marks" onChange={(e)=>setNegativeMarks(e.target.value)} />
                                </div>
                                
                            </div>
                            <div className="form-row">
                                <label>Question</label>
                                <textarea className="form-control" value={question} placeholder="Question" onChange={(e)=>setQuestion(e.target.value)} />
                            </div>
                            {options.map((value, index)=>{<div className="form-row">
                                    <div>
                                        <input
                                            type="radio"
                                            name="dynamic-radio"
                                            value={index}
                                            onChange={(e) => setSelectedOption(index)}
                                        />
                                        <input className="form-control" value={options[index].value} placeholder="Question" onChange={(e)=> {options[index].value=e.target.value}} />
                                        </div>
                                    </div>
                            })}
                            <div className="form-row">
                                <label>Solution</label>
                                <textarea className="form-control" value={solution} placeholder="Solution" onChange={(e)=>setSolution(e.target.value)} />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button className="btn btn-primary" disabled={processing}>
                            {processing?(
                                <ClipLoader color="white" loading={processing} size={20} />
                            ):("Add Video")}
                        </button>
                    </ModalFooter> 
                 </form>
            </Modal>
        </div>
    )
}
export default AddEditTestSeries
